// Auto-generated skeleton for Changelog

export const Changelog: Api.Changelog = {
  id: 0,
  type_id: 0,
  version_id: 0,
  module_id: 0,
  jira_issue_id: '',
  subject: '',
  text: '',
  created_at: '',
  updated_at: '',
};

